module.exports = __webpack_public_path__ + "img/Cargo Bike Woman.bab3e69.svg";